// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  staging: true,
  baseUrl: 'https://service-stg.home365.co',
  version: '1.0.1',
  Keycloak: {
    baseUrl: 'https://keycloak.home365.co/auth/realms/TestRealm/protocol/openid-connect/token',
    keyCloakUserName: 'user1',
    keyCloakClientId: 'test-client',
    keyCloakPassword: '123'
  },
  applicantBaseUrl: 'https://app-stg.home365.co/staging/applicant-app',
  userBaseUrl: 'https://app-stg.home365.co/staging/tenant',
  baseUrlNotification: 'https://app-stg.home365.co/staging/notifications',
  fixetUserId:'e53f7fc6-a154-11ed-a8fc-0242ac120002',
  aws: {
    accessKeyId: 'AKIAJ7EEQFXTXP5HPYTA',
    secretAccessKey: '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',
    region: 'us-east-1',
    folder: 'propertydoc_qa/',
    foleder_files: 'importfiles_qa/'
  },
  portalURL: 'https://staging.home365.co'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
